"use client"

import { usePathname } from "next/navigation"
import dynamic from "next/dynamic"
import { Hero } from "@/components/sections/Hero"
import { Stats } from "@/components/sections/Stats"
import { Services } from "@/components/sections/Services"
import { CTA } from "@/components/sections/CTA"
import { type Locale } from "@/lib/i18n"

// Lazy load below-the-fold components
const DreamAssistantPreview = dynamic(() => import("@/components/sections/DreamAssistantPreview").then(mod => ({ default: mod.DreamAssistantPreview })), {
  loading: () => null,
  ssr: true,
})

const References = dynamic(() => import("@/components/sections/References").then(mod => ({ default: mod.References })), {
  loading: () => null,
  ssr: true,
})

const BlogPreview = dynamic(() => import("@/components/sections/BlogPreview").then(mod => ({ default: mod.BlogPreview })), {
  loading: () => null,
  ssr: true,
})

const DreamAssistant = dynamic(() => import("@/components/sections/DreamAssistant").then(mod => ({ default: mod.DreamAssistant })), {
  loading: () => null,
  ssr: true,
})

export default function HomePage() {
  const pathname = usePathname()
  const currentLocale: Locale = pathname?.startsWith('/en/') ? 'en' : 'tr'
  
  return (
    <>
      <Hero locale={currentLocale} />
      <Stats locale={currentLocale} />
      <Services locale={currentLocale} />
      <DreamAssistantPreview locale={currentLocale} />
      <References locale={currentLocale} />
      <BlogPreview locale={currentLocale} />
      <CTA locale={currentLocale} />
      <DreamAssistant locale={currentLocale} />
    </>
  )
}

